export default __webpack_public_path__ + "static/media/dark-universes-logo-text.8c59a7ee.png";